// extracted by mini-css-extract-plugin
module.exports = {"root":"TheoretischeFahrpruefungPage_root__2QT7V","mainImage":"TheoretischeFahrpruefungPage_mainImage__M26l_","mainTitle":"TheoretischeFahrpruefungPage_mainTitle__25WXG"};